import React from "react";
import "./index.scss";
import wisdomLogo from "../../assets/logos/wisdomWhiteLogo.png";
import ineffableInventionsLogo from "../../assets/logos/ineffableInventions.png";
import { Link } from "react-router-guard";
import Banner from "../../components/banner";
import UserBanner from "../../components/userBanner";
import storeContainerBackground from "../../assets/backgrounds/lightBG.jpg";
import FloatingButton from "components/reusable/floating-button";

const showBanner = process.env.REACT_APP_BANNER === "true";
const supportEmail = "servicioalcliente@wisdom.net.co";

const StoreLayout = ({
	children,
	store,
	guardData,
	hideLastSeparator = false,
	subject = "",
}) => {
	return (
		<>
			<div
				id="storeContainer"
				className="bg-primary"
				style={{ backgroundImage: `url(${storeContainerBackground})` }}
			>
				{showBanner && <Banner />}
				{guardData.sub && <UserBanner guardData={guardData} />}
				<div
					id="storeContentContainer"
					className="container d-flex justify-content-center align-items-center pt-5 pb-5"
				>
					<div
						id="storeContentRow"
						className="row bg-secondary shadow-lg border-white border rounded pt-5 pb-5 text-center text-white"
					>
						<div className="col-12">
							{store ? (
								<Link to="/">
									<img id="wisdomGoldLogo" src={wisdomLogo} alt="Wisdom Logo" />
								</Link>
							) : (
								<a
									href="https://wisdom.net.co/"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img id="wisdomGoldLogo" alt="Wisdom Logo" src={wisdomLogo} />
								</a>
							)}
							<h5 className="mt-2">ONLINE STORE</h5>
						</div>
						<div className="col-lg-6 col-md-10 mx-auto mt-2 mb-2">
							<hr className="bg-primary" />
						</div>
						<div className="col-12"></div>
						{children}
						<div className="col-12"></div>
						<div className="col-lg-8 mx-auto text-center d-block">
							{!hideLastSeparator && <hr className="mt-4 bg-primary" />}
							<p className="mb-0">
								Si necesitas asesoría con tu pedido por favor comunícate con
								nosotros al correo&nbsp;
								<a
									className="font-weight-bold"
									href={`mailto:${supportEmail}?subject=${
										subject ? subject : "Wisdom%20Store"
									}`}
								>
									{supportEmail}
								</a>
								&nbsp;o por medio de nuestro{" "}
								<a
									className="font-weight-bold"
									target="_blank"
									href="https://api.whatsapp.com/send?phone=573174301327"
									rel="noopener noreferrer"
								>
									asistente virtual
								</a>
							</p>
						</div>
					</div>
					<div className="row w-100">
						<div
							id="ineffableInventions"
							className="col-12 text-center text-white mt-5"
						>
							<p className="text-center small mb-3 font-weight-bold">
								Desarrollado por
							</p>
							<a
								className="text-center"
								target="_blank"
								href="https://ineffableinventions.com.co"
								rel="noopener noreferrer"
							>
								<img
									className="zoom-tilt img-fluid"
									src={ineffableInventionsLogo}
									alt="Ineffable Inventions Logo"
								/>
							</a>
						</div>
					</div>
				</div>
			</div>
			<FloatingButton />
		</>
	);
};

export default StoreLayout;
